// Иконки вкладок по серверному имени (config.navigation.tab_bar[].icon) — аналоги SF Symbols MLS iOS:
// matches=sportscourt, leagues=trophy, favorites=star, news=newspaper, highlights=play.rectangle.
// Незнакомое имя → общая иконка (кружок): вкладка видна, приложение не падает.
import styles from './Icon.module.css';

const PATHS: Record<string, string> = {
  matches: 'M3 5h18v14H3zM12 5v14M3 9h3v6H3M21 9h-3v6h3M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3',
  leagues: 'M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M12 14v4M8 21h8M9 18h6',
  favorites: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  news: 'M4 5h13v14H6a2 2 0 0 1-2-2zM17 9h3v8a2 2 0 0 1-2 2M7 8h7M7 11h7M7 14h4',
  highlights: 'M4 6h16v12H4zM10 9.5v5l4.5-2.5z',
};

/** Есть своя картинка у имени иконки (иначе — общая). */
export const hasTabIcon = (name: string) => name in PATHS;

export function TabIcon({ name, filled }: { name: string; filled: boolean }) {
  const d = PATHS[name];
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"
      fill={filled ? 'currentColor' : 'none'} fillOpacity={filled ? 0.18 : 0}
      stroke="currentColor" strokeWidth={filled ? 2 : 1.6} strokeLinejoin="round" strokeLinecap="round">
      {d ? <path d={d} /> : <circle cx="12" cy="12" r="7" />}
    </svg>
  );
}

/** Одноцветная svg-иконка из ассетов, цветом текста (маска). */
export function MaskIcon({ src, size = 24 }: { src: string; size?: number }) {
  const url = `url("${src}")`;
  return <span className={styles.mask} style={{ width: size, height: size, maskImage: url, WebkitMaskImage: url }} aria-hidden="true" />;
}
